import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { ROUTES } from '@/config/routes'
import { AlertCircle } from 'lucide-react'

export const InviteAlreadyUsedPage = () => {
  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-orange-600" />
            <CardTitle>Invite Already Used</CardTitle>
          </div>
          <CardDescription>This invitation has already been accepted</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-md bg-orange-50 p-4 text-sm text-orange-800">
            The invitation link you followed has already been used to create an account.
            Each invitation can only be used once for security purposes.
            <br /><br />
            If you already created an account using this invitation, please log in below.
            If you did not create an account, please contact your administrator.
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-2">
          <Button asChild className="w-full">
            <Link to={ROUTES.LOGIN}>
              Go to Login
            </Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to={ROUTES.SIGNUP}>
              Create New Account
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}
